import * as React from "react";
import { isOnshipDomain } from "../../utils/DomainsHelper";

// Simple class name utility
function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Label({
  className,
  highlightEmail,
  labelError,
  isFocused,
  children,
  ...props
}) {
  // Adjust text size based on domain
  const textSize = isOnshipDomain ? "text-size-13" : "text-size-12";

  return (
    <label
      className={cn(
        "block absolute top-[-8px] left-3 z-10 px-1 bg-white font-medium transition-colors",
        textSize,
        labelError
          ? "text-red"
          : highlightEmail || isFocused
          ? "text-blue"
          : "text-gray-300",
        className
      )}
      {...props}
    >
      {children}
    </label>
  );
}

export { Label };
